import React, { useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import classes from "./Carousel.module.css";
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const Carousel = ({ slides = [], showDots = true }) => {
  const [current, setCurrent] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const handleChangeIndex = (index) => {
    setCurrent(index);
  };
  return (
    <div
      className={classes["slider-wrapper"]}
      onMouseOver={() => setAutoplay(false)}
      onMouseLeave={() => setAutoplay(true)}
    >
      <AutoPlaySwipeableViews
        index={current}
        onChangeIndex={handleChangeIndex}
        animateTransitions={true}
        enableMouseEvents
        autoplay={autoplay}
      >
        {slides.map((slide, idx) => {
          return <div key={idx}>{slide}</div>;
        })}
      </AutoPlaySwipeableViews>
      {showDots && (
        <div className={classes["pagination-wrapper"]}>
          {slides.map((slide, index) => {
            return (
              <div
                key={index}
                className={classes["pagination-item"]}
                style={{
                  backgroundColor: index === current ? "#212121" : "#C4C4C4",
                }}
                onClick={() => handleChangeIndex(index)}
              ></div>
            );
          })}
        </div>
      )}
    </div>
  );
};
export default Carousel;
